import { axiosPost } from '../ServiceBase.js';

export const SOLO_AMBULATORIOS = 'soloAmbulatorios';
export const SOLO_PLANES_ESPECIALES = 'soloPlanesEspeciales';

export const findRecetasElectronicas = async (data) => {
  const recetas = await axiosPost('/v1/busquedas/receta-electronica/buscar', data);
  return recetas;
};
